import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Spinner from "../Component/extra/spinner/Spinner";
import { apiClient } from "../api/client";
import { clearAuthToken, getAuthToken } from "./authToken";

const AuthRoute = () => {
  const [checking, setChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const isAuth = sessionStorage.getItem("isAuth");
  const token = getAuthToken();
  const location = useLocation();

  useEffect(() => {
    let active = true;
    const bootstrapAuth = async () => {
      if (!token || !isAuth) {
        if (active) {
          setIsAuthorized(false);
          setChecking(false);
        }
        return;
      }

      const res = await apiClient.get("/v1/auth/me");
      if (!active) {
        return;
      }

      if (res.ok && res.data?.ok) {
        setIsAuthorized(true);
      } else {
        const unauthorized =
          res.status === 401 || res.data?.error?.code === "UNAUTHORIZED";
        if (unauthorized || !res.ok || !res.data?.ok) {
          clearAuthToken();
          sessionStorage.removeItem("isAuth");
          sessionStorage.removeItem("key");
        }
        setIsAuthorized(false);
      }
      setChecking(false);
    };

    bootstrapAuth();
    return () => {
      active = false;
    };
  }, [token, isAuth]);

  // While login status is being checked, avoid rendering anything or show loader
  if (checking) {
    return <Spinner />;
  }

  // Case 1: If token and isAuth exist, user is authenticated, render the protected routes
  if (token && isAuth && isAuthorized) {
    return <Outlet />;
  }

  // Case 2: User not logged in or invalid session, redirect to login
  return <Navigate to="/admin-login" state={{ from: location }} replace />;
};

export default AuthRoute;
